import React, { useState, useCallback } from 'react'
import ConfirmationModal from '../../components/modals/confirmation'
import confirmationDialogContext from '../../contexts/confirmation-dialog'

const ConfirmationDialogProvider = ({ children }) => {
    const [ dialog, setDialog ] = useState()

    const showConfirmation = useCallback(({
        title = 'Are you sure?',
        confirmLabel = 'Confirm',
        cancelLabel = 'Cancel',
        description,
        onConfirm = () => {},
        onCancel = () => {}
    }) => {
        setDialog({
            title,
            confirmLabel,
            cancelLabel,
            description,
            onConfirm,
            onCancel
        })
    }, [])

    const onConfirm = useCallback(() => {
        const callback = dialog.onConfirm
        setDialog()
        callback()
    }, [dialog])

    const onCancel = useCallback(() => {
        const callback = dialog.onCancel
        setDialog()
        callback()
    }, [dialog])


    return (
        <confirmationDialogContext.Provider value={{
            showConfirmation
        }}>
            {children}
            {Boolean(dialog) &&
            <ConfirmationModal
                confirmLabel={dialog.confirmLabel}
                cancelLabel={dialog.cancelLabel}
                title={dialog.title}
                onConfirm={onConfirm}
                onCancel={onCancel}
                visible
            >
                {dialog.description}
            </ConfirmationModal>
            }
        </confirmationDialogContext.Provider>
    )

}

export default ConfirmationDialogProvider